import React from 'react';

import {Container, Spinner} from './styles';
import {useTheme} from 'styled-components';

interface Props {
  flex?: boolean;
  size?: number;
  color?: string;
}

const Loading: React.FC<Props> = ({flex = true, size = 18, color}) => {
  const {colors} = useTheme();
  if (!flex) return <Spinner {...{size}} />;

  return (
    <Container>
      <Spinner {...{size, color: color ?? colors.primary}} />
    </Container>
  );
};

export default Loading;
